import React from 'react';
import { X } from 'lucide-react';

interface TermsOfServiceModalProps {
  onClose: () => void;
}

export default function TermsOfServiceModal({ onClose }: TermsOfServiceModalProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white p-4 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-900">Termos de Serviço</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="p-6 space-y-6">
          <section>
            <h3 className="text-lg font-semibold mb-3">1. Introdução</h3>
            <p className="text-gray-600">
              Bem-vindo ao Kontty! Estes Termos de Serviço regem o uso de nossa plataforma e serviços. 
              Ao acessar ou usar o Kontty, você concorda em cumprir estes termos.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">2. Aceitação dos Termos</h3>
            <p className="text-gray-600">
              Ao utilizar nossos serviços, você confirma que tem pelo menos 16 anos de idade e capacidade legal 
              para celebrar estes termos. Se você não concorda com estes termos, por favor não utilize nossos serviços.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">3. Serviços Prestados</h3>
            <p className="text-gray-600">
              Kontty oferece serviços de criação de conteúdo que visam ajudar os usuários a elevar sua presença online. 
              Isso inclui criação de vídeo, conteúdo de mídia social e serviços relacionados.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">4. Contas de usuário</h3>
            <p className="text-gray-600">
              Para acessar determinados recursos, pode ser necessário criar uma conta. Você concorda em fornecer 
              informações precisas e completas e em manter sua conta segura.
            </p>
            <ul className="list-disc ml-6 mt-2 text-gray-600">
              <li>Segurança da conta: Você é responsável por manter a confidencialidade de sua conta e senha.</li>
              <li>Atividade da conta: Você concorda em nos notificar imediatamente sobre qualquer uso não autorizado de sua conta.</li>
            </ul>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">5. Propriedade do conteúdo</h3>
            <p className="text-gray-600">
              Você retém todos os direitos sobre qualquer conteúdo criado usando nossos serviços. Ao usar o Kontty, 
              você nos concede uma licença não exclusiva, mundial e isenta de royalties para usar, reproduzir e exibir 
              seu conteúdo com a finalidade de fornecer nossos serviços.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">6. Atividades Proibidas</h3>
            <p className="text-gray-600">
              Você concorda em não se envolver em nenhuma das seguintes atividades proibidas:
            </p>
            <ul className="list-disc ml-6 mt-2 text-gray-600">
              <li>Utilizar o serviço para fins ilegais ou em violação de quaisquer leis aplicáveis.</li>
              <li>Publicar ou compartilhar conteúdo difamatório, abusivo ou que viole os direitos de terceiros.</li>
              <li>Tentativa de obter acesso não autorizado aos nossos sistemas ou contas.</li>
            </ul>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">7. Rescisão</h3>
            <p className="text-gray-600">
              Reservamo-nos o direito de suspender ou encerrar sua conta se você violar estes termos ou se envolver 
              em atividades proibidas.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">8. Isenção de Garantias</h3>
            <p className="text-gray-600">
              Nossos serviços são fornecidos "no estado em que se encontram", sem garantias de qualquer tipo. 
              Não garantimos que nossos serviços serão livres de erros ou ininterruptos.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">9. Limitação de Responsabilidade</h3>
            <p className="text-gray-600">
              Na extensão máxima permitida por lei, Kontty não será responsável por quaisquer danos indiretos, 
              incidentais ou consequenciais decorrentes do uso de nossos serviços.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">10. Alterações nos Termos</h3>
            <p className="text-gray-600">
              Poderemos atualizar estes Termos de Serviço de tempos em tempos. Iremos notificá-lo sobre quaisquer 
              alterações publicando os novos termos em nosso site. O uso continuado dos serviços após quaisquer 
              alterações constitui sua aceitação dos novos termos.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">11. Lei Aplicável</h3>
            <p className="text-gray-600">
              Estes termos serão regidos e construídos de acordo com as leis da legislação indiana.
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold mb-3">12. Informações de contato</h3>
            <p className="text-gray-600">
              Se você tiver alguma dúvida sobre estes Termos de Serviço, entre em contato conosco pelo 
              e-mail team.novacontent@gmail.com.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}